import { Watch, BaseTLDetailComponent, AxiosResponse, EnumsService, EnumsFilter, ObjectTypesHelper, tlDateToISOString, tlISODateTimeToLocalNoSecondsString } from "../../../Infrastructure/CorBase/CoreBase";
import { ContentService, ContentPreviewService } from "../../../Services/ContBase/AllConServices";
import { TenantpaidService } from "../../../Services/AccBase/AllAccServices";

import TagModal from "../../../Components/ComponentsBase/BaseTLModalDialogTag.vue";
import ModalDetail from "../../../Components/ComponentsBase/BaseTLModalDialogDetail.vue";


	export default abstract class ContentDetailBase extends BaseTLDetailComponent {
		returnRoute = "ContentList";
		contentService: ContentService = new ContentService();
		tenantPaidService: TenantpaidService = new TenantpaidService();
		enumsService: EnumsService = new EnumsService();
		contentPreviewService: ContentPreviewService = new ContentPreviewService();
		objectType: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.Content;
		fileContent: File | null = null;
		enums: any[] = [];

		imageTest = "";
		showVideoTag = false;
		isDownloadVideo = false;

		mainProps = {
			block: false,
			center: true,
			fluid: false,
			fluidGrow: false,
			blank: true,
			heigt: 200,
			width: 100,
			blankColor: '#bbb',

			class: 'my-5'
		}
				

		formData = {
			id: 0 as number,
			fileSumCheckDetail: '' as string,
			fileSumCheckDetailAnimated: '' as string,
			changeContent: false as boolean,
			image: null,
			idTenant: this.$store.state.idTenant as number,
			idContentType: 0 as number,
			idContentTypeIdentifier: '' as string,
			name: '' as string,
			description: '' as string | null,
			url: '' as string | null,
			idContentVariantFileName: '' as string | null,
			idTaskNavigationName: '',
			idContentVariantFileSize: 0 as number,
			idContentTypeNavigationName: '' as string,
			idContentVariantTransocerParameterResolution: '' as string,
			idContentVariantTransocerParameterCodek: '' as string,
			idContentVariantTransocerParameterAudioCodek: '' as string,
			idContentVariantParameters: '',
			idContentVariantCacheFileSize: '' as string,
			idContentVariantSumFileCacheSize: '' as string,
			showSumFileSize: false as boolean,
			idContentPreviewStatic: 0 as number,
			idContentPreviewAnimated: 0 as number,
			contentPreviewAlt: '' as string,
			contentPreviewTitle: '' as string,
			idContentVariantLength: 0 as number,
			taskList: [] as Array<any>,
			showDeleteCache: false as boolean,
			showCache: false as boolean,
			canDeleteCache: false as boolean,
			canDownloadFile: false as boolean,
			creationDate: '' as string | null,
			whenChanged: '' as string | null,
			isFromFile: false as boolean,  
			isText: true as boolean,
			isUrl: false as boolean,
			value: '' as string,
			tags: [] as Array<any>,
			urlLink: {id: "1", name: "www.seznam.cz"},
			isRefreshNeeded: false as boolean,
		};

		htmlEdit = '';
		htmlEditOld = '';


		fileSize = 0;
		fileSizeRest = 0;

		contentErrorMsg = '';
		showContentError = false;
		
		refreshCounter: number = 0;

		clearContentError()	{
			this.showContentError = false;
			this.contentErrorMsg = '';
		}

        @Watch('fileContent')
        onPropertyChangedIdContentType(value: File, oldValue: File) {
            if (value !== oldValue) {
                if (this.fileContent) {
                    this.loadRemaingDiskSpace();
                    const fileSizeInBytes = this.fileContent.size;
                    this.fileSize = fileSizeInBytes / (1024 * 1024); // Převod na MB
                    if (this.fileSizeRest < this.fileSize) {
                        this.$t('contentDetail.fileSizeError').toString();
                        let message = this.$t('contentDetail.fileSizeError').toString().replace("{0}", this.fileSizeRest.toFixed(2).toString());
						this.contentErrorMsg = message;
						this.showContentError = true;
                        this.showErrorMessage(message);
                    } else {
						this.clearContentError();
					}
                }
            }
        }

		@Watch('formData.idContentType')
		onPropertyChanged(value: number, oldValue: number) {
			if (value !== oldValue) {
				this.fileContent = null;
				this.clearContentError();
			}
		}

		staticPreviewId(): number | null {
			return this.formData.fileSumCheckDetail == null || this.formData.idContentPreviewStatic == null || this.formData.idContentPreviewStatic <= 0 ? 0 : this.formData.idContentPreviewStatic;
		}

		animatedPreviewId(): number | null {
			return this.formData.fileSumCheckDetailAnimated == null || this.formData.idContentPreviewAnimated == null || this.formData.idContentPreviewAnimated <= 0 ? 0 : this.formData.idContentPreviewAnimated;
		}

		//nacteni zbyvajiciho prostoru
		loadRemaingDiskSpace() {
			this.tenantPaidService.getRemainingDiskSpace(this.$store.state.idTenant).then(res => {
				this.fileSizeRest = res.data;
			});
		}

		createdBase() {
			this.loadRemaingDiskSpace();
		}

		changeTagsBase(items: any): void {
			this.formData.tags = items;
		}

		loadingAfterCreate = false;
		oldFileSumCheck = "";
		refreshAfterUpdate() {
			if (this.identifierTypeContent() == 'ENU_CON_Content_Type_Video'
				|| this.identifierTypeContent() == 'ENU_CON_Content_Type_Image'
				|| (this.identifierTypeContent() == 'ENU_CON_Content_Type_HtmlContent' && this.formData.isFromFile)
				|| this.identifierTypeContent() == 'ENU_CON_Content_Type_HtmlContent'
				|| this.identifierTypeContent() == 'ENU_CON_Content_Type_LinkToUrl') {
				this.loadingAfterCreate = true;
				this.oldFileSumCheck = this.formData.fileSumCheckDetail;
				this.refreshCounter = 1;
				this.setRefreshTimeout();
			}
		}

		setRefreshTimeout() {
			clearInterval(this.timerHandle);
			this.timerHandle = setTimeout(() => {
				this.refreshAfterUpdateBody();
			}, 5000 * this.refreshCounter);
		}

		refreshAfterUpdateBody() {
			//TODO neni jak na jistotu zjistit ze to video, nebo obrazek je jiz prirapraven proto kazde 5 sekund to zkusim
			this.contentService.getById(this.formData.id).then(response => {
				this.processResponse(response);	
			}).finally(() => {
				if (this.formData.isRefreshNeeded || this.formData.fileSumCheckDetail == null) {
					this.refreshCounter++;
					//if (this.refreshCounter > 4) {
					//	this.loadingAfterCreate = false;
					//}
					this.setRefreshTimeout();
				} else {
					this.loadingAfterCreate = false;
					clearInterval(this.timerHandle);
				}
			});

			//puvodni nezabralo
			//this.contentService.getRefreshById(this.formData.id).then(response => {
			
				
			//	this.formData.idContentPreviewAnimated = response.data.idContentPreviewAnimated;
			//	this.formData.contentPreviewTitle = response.data.contentPreviewTitle;
			//	this.formData.contentPreviewAlt = response.data.contentPreviewAlt;
			//	this.formData.idContentPreviewStatic = response.data.idContentPreviewDetailStatic;
			//	this.formData.fileSumCheckDetail = response.data.fileSumCheckDetail;

			//	if (this.formData.fileSumCheckDetail != this.oldFileSumCheck) {
			//		clearInterval(this.timerHandle);
			//	}
			//});
		}
/*
		setRefresh(data: any) {
			if (this.timerHandle > 0)
				return;

			if (data.IsAwaitingPreview) {			
				this.previewRefreshCounter++;
				console.log("setPreviewRefresh in ", this.previewRefreshCounter * 5000);	
				this.previewRefreshTimerHandle = setTimeout(() => {
					this.fetchRefreshData();
				}, 5000 * this.previewRefreshCounter);
			}
			else {
				this.previewRefreshCounter = 0;
				console.log("setPreviewRefresh disable");	
				clearTimeout(this.previewRefreshTimerHandle);
			}
		}
*/
		changeHtmlEditorBase(html: string) {
			this.formData.changeContent = true;
			if (this.htmlEditOld == '') {
				this.htmlEditOld = this.htmlEdit;
			}
			this.htmlEdit = html;
        }

		lastIdComponent = 0;
		addNewTag(item: any) {
			this.$bvModal.show('tagDialog');
			this.lastIdComponent = Number(item.id);
			(this.$refs.tagModal as TagModal).setSelected(item.tags, this.lastIdComponent, item.name);
		}

		gridColor(color: string): string {
			return 'background-color: ' + color + ';';
		}

		goBackDetailTagBase(item: any): void {
			let tags: any = this.formData.tags;
			if (tags != null) {
				let changeItem = tags.filter((c: any) => c.id == item.id)[0];
				changeItem.name = item.name;
				changeItem.color = item.color;
			}
		}

		tagDetail(item: any): void {
			this.$bvModal.show('detailModal');
			(this.$refs.detailModal as ModalDetail).setSelected(String(item.id));
		}

		//tagy end

		///hlaska o prekroceni inputu po Ctrl+V
		protected infoShortInputBase(maxLength: string): void {
			this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
		}

		get showDeleteCacheButton(): boolean {
			return !this.formIsInEditMode && !this.styleFormNew && !this.styleFormDelete && (this.formData.showDeleteCache);
		}

		allTask: any[] = [];

		getPreviewId(id: number | null | undefined): string {
			return `image_detail_content_${id}`;
		}

		deleteCache() {
			this.contentService.deleteCache(this.formData.id).then(res => {
				this.formData.canDeleteCache = false;
				if (res.data.errors.length > 0) {
					this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), res.data.errors[0]);
				}
				else {
					this.formData.idContentVariantCacheFileSize = '0 B';

				}
			//	this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('content.messageDeleteCache').toString() );
            }).catch(error => {
				this.showAlertModalWithErrorMessageList(error.data.errors);
            });
		}

		imageProp() {
			return { width: 120, height: 120, class: 'm1' };
		}

		prepareImage(image: any) {
			return 'data:image/jpeg;base64,' + image;
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.contentService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall();
			//this.formData.isActive = refreshData.isActive;
		}

		protected refreshItems(items: any, refreshData: any): any {
			/*		
			this.setRefresh(refreshData);
			this.formData.idContentPreviewAnimated = refreshData.idContentPreviewAnimated;
			this.formData.contentPreviewTitle =refreshData.contentPreviewTitle;
			this.formData.contentPreviewAlt = refreshData.contentPreviewAlt;
			this.formData.idContentPreviewStatic = refreshData.idContentPreviewDetailStatic;
			this.formData.fileSumCheckDetail = refreshData.fileSumCheckDetail;
			*/
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.fileSumCheckDetail = response.data.fileSumCheckDetail;
			this.formData.fileSumCheckDetailAnimated = response.data.fileSumCheckDetailAnimated;
			this.formData.taskList = response.data.taskList;
			this.formData.image = response.data.image;
			this.formData.idTenant = response.data.idTenant;
			this.formData.idContentType = response.data.idContentType;
			this.formData.idContentTypeIdentifier = response.data.idContentTypeIdentifier;
			this.formData.name = response.data.name;
			this.formData.description = response.data.description;
			this.formData.url = response.data.url;
			this.formData.idContentVariantFileName = response.data.idContentVariantFileName;
			this.formData.idTaskNavigationName = response.data.idTaskNavigationName;
			this.formData.idContentVariantParameters = response.data.idContentVariantParameters;
			this.formData.idContentVariantFileSize = response.data.idContentVariantFileSize;
			this.formData.idContentVariantTransocerParameterResolution = response.data.idContentVariantTransocerParameterResolution;
			this.formData.idContentVariantTransocerParameterCodek = response.data.idContentVariantTransocerParameterCodek;
			this.formData.idContentVariantTransocerParameterAudioCodek = response.data.idContentVariantTransocerParameterAudioCodek;
			this.formData.idContentVariantCacheFileSize = response.data.idContentVariantCacheFileSize;
			this.formData.idContentPreviewStatic = response.data.idContentPreviewDetailStatic;
			this.formData.idContentPreviewAnimated = response.data.idContentPreviewDetailAnimated;
			this.formData.contentPreviewAlt = response.data.contentPreviewAlt;
			this.formData.contentPreviewTitle = response.data.contentPreviewTitle;
			this.formData.idContentVariantLength = response.data.idContentVariantLength;
			this.formData.idContentTypeNavigationName = response.data.idContentTypeNavigationName;
			this.formData.showDeleteCache = response.data.showDeleteCache;
			this.formData.showCache = response.data.showCache;
			this.formData.canDeleteCache = response.data.canDeleteCache;
			this.formData.canDownloadFile = response.data.canDownloadFile;
			this.formData.creationDate = tlISODateTimeToLocalNoSecondsString(response.data.creationDate);
			this.formData.whenChanged = tlISODateTimeToLocalNoSecondsString(response.data.whenChanged);
			this.formData.tags = response.data.tags;
			this.formData.isFromFile = response.data.isFromFile;
			this.formData.value = response.data.value;
			this.formData.idContentVariantSumFileCacheSize = response.data.idContentVariantSumFileCacheSize;
			this.formData.showSumFileSize = response.data.showSumFileSize;
			this.formData.isRefreshNeeded = response.data.isRefreshNeeded;
			if (this.formData.url != null) {
				this.formData.urlLink = {
					id: "1", name: this.formData.url+""
				};
			}

			this.formData.isText = this.formData.value != ''; 
			this.formData.isUrl = this.formData.url != null;
			
			this.loadEnums();
		}

		protected doAction() {
			var updateMesage = this.showHtmlInput() && this.formData.taskList.length>0 ? this.$t('contentDetail.messageUpdateHtml').toString() : this.$t('content.messageEdit').toString();
			super.doCRUDActionWithInfoMessage(this.$t('content.messageNew').toString(), updateMesage, this.$t('content.messageDelete').toString());
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			clearInterval(this.timerHandle);
			let formData: FormData = this.dataToFormData();
			this.formData.whenChanged = tlISODateTimeToLocalNoSecondsString(new Date);
			var rrr = this.contentService.update(this.objectId, formData);
			if (this.formData.url != null) {
				this.formData.urlLink = {
					id: "1", name: this.formData.url + ""
				};
			}
						
			return rrr;
		}

		protected afterUpdate(response: AxiosResponse<any>): void {
			this.refreshAfterUpdate();
		}
		
		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.creationDate = tlISODateTimeToLocalNoSecondsString(response.data.creationDate);
			this.formData.whenChanged = tlISODateTimeToLocalNoSecondsString(response.data.creationDate);
			if (this.formData.url != null) {
				this.formData.urlLink = {
					id: "1", name: this.formData.url + ""
				};
			}
			if (this.showFileInput()) {
				this.formData.idContentVariantFileName = (this.fileContent == null ? "" : this.fileContent.name);
			}
			this.downloadAudioForPlay(true);
			this.refreshAfterUpdate();
		}

		protected createObject(): Promise<AxiosResponse<any>> {
			clearInterval(this.timerHandle);
			let formData: FormData = this.dataToFormData();
			var e = (document.getElementById("idContentType")) as HTMLSelectElement;
			this.formData.idContentTypeNavigationName = e.selectedOptions[0].innerText;
			return this.contentService.create(formData);
		}

		async deletetest() {
			return await this.contentService.delete(this.objectId);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.contentService.delete(this.objectId);
		}

		private dataToFormData(): FormData {
			let formData: FormData = new FormData();
			
			formData.append('id', this.formData.id.toString());
			formData.append('idTenant', this.formData.idTenant.toString());
			formData.append('whenChanged', tlDateToISOString(new Date()));
			formData.append('idContentType', this.formData.idContentType.toString());
			formData.append('name', this.formData.name);
			if (this.formData.description) {
				formData.append('description', this.formData.description.toString());
			}
			if (this.formData.url && (this.showUrlInput() || (this.showInfoText() && this.formData.isUrl))) {
				formData.append('url', this.formData.url.toString());
			}

			if (this.showInfoText()) {
				if (this.formData.isText) {
					formData.append('value', this.formData.value.toString());
				}
			}

			if (this.fileContent !== null) {
				formData.append('fileContent', this.fileContent);
				formData.append('changeContent', this.formData.changeContent.toString());
			}

			//var contents = fs.readFileSync('./dmv_file_reader.txt').toString()
			if (this.showHtmlInput() && !this.formData.isFromFile) {
				var blob = new Blob([this.htmlEdit], { type: 'text/html' });
				var file = new File([blob], this.formData.name + "_htmlEdit.html", { type: "text/html" });
				this.fileContent = file;

				//formData.append('fileContent', this.formData.changeContent.toString());
				formData.append('fileContent', this.fileContent);
				formData.append('changeContent', this.formData.changeContent.toString());
			}
			else {
				this.formData.isFromFile = this.showFileInput() || (this.showInfoText() && this.formData.isFromFile);
			}
			formData.append('isFromFile', this.formData.isFromFile.toString());
			this.htmlEditOld = this.htmlEdit;
			return formData;
		}

		loadEnums() {
			let enumsFilter: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, 'ENU_CON_Content_Type', false);
			this.enumsService.getAllByFilter(enumsFilter).then((response) => {
				this.enums = response.data;
				this.downloadAudioForPlay();
				this.downloadHtmlEditorSource();
			});
		}

		identifierTypeContent() {
			if (this.formData.idContentType != undefined && this.formData.idContentType > 0 && this.enums.length > 0) {
				return this.enums.filter(c => c.id == this.formData.idContentType)[0].identifier;
			}
			return '';
		}

		showFileInput() {
			var result = ((this.identifierTypeContent() == 'ENU_CON_Content_Type_HtmlContent' && this.formData.isFromFile) || this.identifierTypeContent() == 'ENU_CON_Content_Type_Image'
				|| this.identifierTypeContent() == 'ENU_CON_Content_Type_Video' || this.identifierTypeContent() == 'ENU_CON_Content_Type_Audio');
			return result;		
		}

		showFileInputAudio() {
			var result = ( this.identifierTypeContent() == 'ENU_CON_Content_Type_Audio');
			return result;
		}

		showFileInputVideo() {
			var result =this.identifierTypeContent() == 'ENU_CON_Content_Type_Video' ;
			return result;
		}

		showFileInputImage() {
			var result = this.identifierTypeContent() == 'ENU_CON_Content_Type_Image';
			return result;
		}

		showFileInputHtml() {
			var result = (this.identifierTypeContent() == 'ENU_CON_Content_Type_HtmlContent' && this.formData.isFromFile);
			return result;
		}

		showHtmlInput() {
			return this.identifierTypeContent() == 'ENU_CON_Content_Type_HtmlContent';
		}

		showInfoText() {
			return this.identifierTypeContent() == 'ENU_CON_Content_Type_InfoText';
		}

		showAudio() {
			return this.identifierTypeContent() == 'ENU_CON_Content_Type_Audio';
		}

		requiredFileInput() {
			//VaPTODO - dodelat a je otazka jak poznat prepinani na typu obsahu, kdyz tam nemame identifikator, ale id
			//if (this.showFileInput()) {
			//	return super.showSaveButton();
			//}
			//return false;
			return false;
		}

		protected showAudioStreamTag(): boolean {
			var result= !this.styleFormNew && this.formData.url != undefined && this.identifierTypeContent() != undefined
				&& (this.identifierTypeContent() == 'ENU_CON_Content_Type_AudioStream');
			return result;
		}

		protected showAudioTag(afterCreate: boolean = false): boolean {
			return (!this.styleFormNew || afterCreate) && (this.identifierTypeContent() == 'ENU_CON_Content_Type_Audio');
		}


		showVideo() {
			return !this.styleFormNew && this.identifierTypeContent() == 'ENU_CON_Content_Type_Video';
		}

		showVideoOrAudio() {
			return !this.styleFormNew && (this.identifierTypeContent() == 'ENU_CON_Content_Type_Video' || this.identifierTypeContent() == 'ENU_CON_Content_Type_Audio');
		}

		showImage() {
			return this.identifierTypeContent() == 'ENU_CON_Content_Type_Image';
		}

		showVideoOrImage() {
			return this.showVideo() || this.identifierTypeContent() == 'ENU_CON_Content_Type_Image';
		}

		showUrlInput() {
			return (this.identifierTypeContent() == 'ENU_CON_Content_Type_AudioStream' || this.identifierTypeContent() == 'ENU_CON_Content_Type_LinkToUrl');
		}

		showDownloadButton(): boolean {
			return !this.formIsInEditMode && this.formData.canDownloadFile;
		}

		intervalId = 0;
		isPlayVideo() {
			this.intervalId = setInterval(this.testPlayVideo, 1000);
		}

		protected classVideo(): string {
			return this.showVideo() ? 'pointerShow' : '';
		}


		testPlayVideo() {
			var videoTag = document.getElementById('vidObj');
			var endVideoPlay = (videoTag as HTMLVideoElement).ended;
			if (endVideoPlay) {
				clearInterval(this.intervalId);
				this.showVideoTag = false;
			}
		}

		beforeDestroyBase() {
			clearInterval(this.intervalId);
		}

		pathToAudio = '';
		isDownloadAudio = false;
		//audio
		downloadAudioForPlay(afterCreate: boolean = false): void {
			if (this.showAudioTag(afterCreate)) {
				this.contentService.getOriginalFileById(this.objectId).then((response) => {
					var myUrl = (window.URL || window.webkitURL).createObjectURL(new Blob([response.data]));
					this.pathToAudio = myUrl;
					var videoTag = document.getElementById('audioObj');
					(videoTag as HTMLAudioElement).src = this.pathToAudio;
					this.isDownloadAudio = true;
					this.formData.canDownloadFile = true;
				}).catch((error) => {
					if (this.fileNotFound(error)) {
						this.showErrorMessage(this.$t('contentDetail.fileNotFound').toString());
					} else {
						this.showErrorMessage(JSON.stringify(error.response.data.errors));
					}
				});
			}
		}

		//html editor
		downloadHtmlEditorSource(afterCreate: boolean = false): void {
			if (this.showHtmlInput()) {
				this.contentService.getOriginalFileById(this.objectId).then((response) => {
					const reader = new FileReader();
					reader.addEventListener('loadend', (e:any) => {						
						this.htmlEdit = e.srcElement.result;
					});
			        reader.readAsText(response.data);
				}).catch((error) => {
					if (this.fileNotFound(error)) {
						this.showErrorMessage(this.$t('contentDetail.fileNotFound').toString());
					} else {
						this.showErrorMessage(JSON.stringify(error.response.data.errors));
					}
				});
			}
		}

		//video
		downloadFileForPlay(): void {
			this.showVideoTag = true;

			this.contentService.getOriginalFileById(this.objectId).then((response) => {
				var myUrl = (window.URL || window.webkitURL).createObjectURL(new Blob([response.data]));
				this.pathToVideo = myUrl;
				var videoTag = document.getElementById('vidObj');
				(videoTag as HTMLVideoElement).src = this.pathToVideo;
				this.isPlayVideo();
				this.isDownloadVideo = true;				
			}).catch((error) => {
				if (this.fileNotFound(error)) {
					this.showErrorMessage(this.$t('contentDetail.fileNotFound').toString());
				} else {
					this.showErrorMessage(JSON.stringify(error.response.data.errors));
				}
			});
		}

		pathToVideo = '';

		playMedia(): void {
			if (this.showDownloadButton() && !this.showImage() && !this.showHtmlInput() && !this.showAudio()) {
				if (this.isDownloadVideo) {
					this.showVideoTag = true;
					var videoTag = document.getElementById('vidObj');
					(videoTag as HTMLVideoElement).play();
					this.isPlayVideo();
				}
				else {
					this.downloadFileForPlay();
				}
			}
		}

		download(): void {
			if (this.formData.canDownloadFile) {
				this.isBusy = true;
				this.contentService.getOriginalFileById(this.objectId).then((response) => {

					this.createFile(response);
					this.isBusy = false;
				}).catch((error) => {
					if (this.fileNotFound(error)) {
						this.showErrorMessage(this.$t('contentDetail.fileNotFound').toString());
					} else {
						this.showErrorMessage(JSON.stringify(error.response.data.errors));
					}
					this.isBusy = false;
				});
			}
		}

		private fileNotFound(response: any): boolean {
			if (response.status) {
				return response.status == 404;
			}
			return false;
		}

		createFile(response: AxiosResponse<any>) {
			var filename = "";
			var disposition = response.headers["content-disposition"];
			var blob = new Blob([response.data]);
			if (disposition && (disposition.indexOf('inline') !== -1 || disposition.indexOf('attachment') !== -1)) {
				var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
				var matches = filenameRegex.exec(disposition);
				if (matches != null && matches[1]) {
					filename = matches[1].replace(/['"]/g, '');
				}
			}
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', filename)
			document.body.appendChild(link)
			link.click()
		}

		vIsCorrectName: boolean = true;
		vIsCorrectContentType: boolean = false;

		vIsCorrectUrl: boolean = true;
		vIsCorrectFile: boolean = true;

		//tuto kontrolu necham az v restovce, protoze prepocitavat pri kazde zmene to neni ono a taky ta velikost je dost malicka
		validateSizeHtml() {
			if (this.showHtmlInput() && !this.formData.isFromFile) {
				var blob = new Blob([this.htmlEdit], { type: 'text/html' });
				var file = new File([blob], this.formData.name + "_htmlEdit.html", { type: "text/html" });				
				var fileSize2 = file.size / (1024 * 1024); // Převod na MB
				return this.fileSizeRest >= fileSize2;
			}
			else {
				return true;
			}
		}

		isNeedFile() {
			return this.identifierTypeContent() == 'ENU_CON_Content_Type_Audio' || this.identifierTypeContent() == 'ENU_CON_Content_Type_Video' || this.identifierTypeContent() == 'ENU_CON_Content_Type_Image' || (this.identifierTypeContent() == 'ENU_CON_Content_Type_HtmlContent' && this.formData.isFromFile);
		}

		validateBase() {
		
			return !(this.vIsCorrectName && this.formData.idContentType != 0 && (this.vIsCorrectUrl || !this.showUrlInput()) &&
				(this.vIsCorrectFile || !this.showFileInput) && (this.fileContent == null
					|| this.fileSizeRest >= this.fileSize) && (!this.isNeedFile() || this.formIsInEditMode ==true|| (this.isNeedFile() && this.fileContent != null))
				//&& this.validateSizeHtml()
			);
		}

		isCorrectFileBase(value: any) {
			this.vIsCorrectFile = this.showFileInput() && this.styleFormNew ? value : true;
		}

		isCorrectUrlBase(value: any) {
			this.vIsCorrectUrl = this.showUrlInput() ? value : true;
		}

		isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}

		isCorrectContentTypeBase(value: any) {
			this.vIsCorrectContentType = this.formData.idContentType > 0;

			this.vIsCorrectContentType = true;
		}
	}